/**
 * The evaluation terms every prospect accepts before using mollusk.io
 * (mollusk-interface#170). The single source for the Terms page, the accept
 * gate and the acceptance record: bump TERMS_VERSION whenever the text changes
 * and every prospect is asked to accept again.
 */
export const TERMS_VERSION = '2026-10-23';
export const TERMS = {
    title: 'Mollusk evaluation terms',
    intro: 'By clicking Accept, you agree to these terms for yourself and your company. They add to any NDA between your company and Mollusk Inc.',
    points: [
        {
            heading: 'Evaluation only.',
            body: 'You may use mollusk.io and any data you download from it only to decide whether to license Mollusk data. Any other use requires a license agreement with Mollusk Inc.',
        },
        {
            heading: 'Keep it in-house.',
            body: "Don't share your login, and don't pass the data to anyone outside your company. Don't sell, publish or redistribute it.",
        },
        {
            heading: 'No models or products during evaluation.',
            body: "Under these terms, don't use the data to train or fine-tune AI models, or build it into any product, database or service. A license agreement with Mollusk Inc can allow both.",
        },
        {
            heading: 'Ownership.',
            body: 'The Mollusk database, including how it is compiled, cleaned and tagged, is the property of Mollusk Inc. Using it gives you no rights beyond these terms.',
        },
        {
            heading: 'We track usage.',
            body: "We log each account's logins, searches and downloads.",
        },
        {
            heading: 'As is.',
            body: 'The data comes from public permit and parcel records. We work to keep it accurate but make no guarantees.',
        },
        {
            heading: 'Access.',
            body: 'We can change or end access at any time. Points 2, 3 and 4 still apply to any data you downloaded.',
        },
    ],
    contact: 'holly@mollusk.io',
};
//# sourceMappingURL=terms.js.map